import { Box, Typography } from "@mui/material";

export default function InfoRow({ label, value }) {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1,
        alignItems: "baseline",
        mb: 0.9,
        minWidth: 0,
      }}
    >
      <Typography
        variant="caption"
        sx={{ opacity: 0.7, minWidth: 120, flexShrink: 0 }}
      >
        {label}
      </Typography>

      <Typography
        sx={{
          fontWeight: 850,
          lineHeight: 1.2,
          minWidth: 0,
          overflowWrap: "anywhere",
          wordBreak: "break-word",
        }}
      >
        {value || "—"}
      </Typography>
    </Box>
  );
}
